import type * as core from '../../../../../core'

export const PACKAGE = {
  contents: [
    'resource:data.dimensions.policies',
    'resource:data.dimensions.policies.entities.policyArea',
    'resource:data.dimensions.policies.entities.policyArea.attributes.sortOrder',
    'resource:data.dimensions.policies.entities.policy',
    'resource:data.dimensions.policies.entities.policy.attributes.documents',
    'resource:data.dimensions.policies.entities.policy.attributes.effectiveDate',
    'resource:data.dimensions.policies.entities.policy.attributes.owner',
    'resource:data.dimensions.policies.entities.policy.attributes.relatedPolicies',
    'resource:data.dimensions.policies.entities.policy.attributes.state',
    'resource:data.dimensions.policies.entities.policy.attributes.topics',
    'resource:data.dimensions.policies.entities.policy.attributes.version',
    'resource:solutions.apps.policies',
    'resource:solutions.apps.policies.pages.policyExplorer',
    'resource:solutions.mosaic.pages.policies.policyExplorer',
    'resource:solutions.mosaic.widgets.policies.policyExplorerTable',
  ],
  description:
    'Company policy data model: policy areas and the policies within them, ' +
    'with each policy document stored in the shared knowledge base scoped to ' +
    'its record, plus the Policies Mosaic app whose Policy Explorer opens the ' +
    'Policy Assistant over one policy, one area, or all policies.',
  name: 'Policies',
} as const satisfies core.quiver.Package
